import { type FC, useId } from "react";

type Props = {
  light: string;
  dark: string;
  locked?: boolean;
  className?: string;
};

const TierBadge: FC<Props> = ({ light, dark, locked = false, className }) => {
  const id = useId();

  if (locked) {
    return (
      <svg
        viewBox="0 0 36 39"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
          fill={`url(#${id}-a)`}
        />
        <path
          d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
          fill={`url(#${id}-b)`}
          fillOpacity="0.4"
        />
        <path
          d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
          stroke={`url(#${id}-c)`}
          strokeWidth="1.8"
        />
        <path
          d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
          stroke={`url(#${id}-d)`}
          strokeWidth="1.8"
        />
        <svg
          viewBox="0 0 24 25"
          fill="none"
          x="7.9"
          y="8.5"
          width="20.2"
          height="21"
        >
          <path
            d="M12.0002 1.25C15.0377 1.25011 17.5002 3.7125 17.5002 6.75V8.52734C19.0678 9.00715 20.2511 10.3866 20.4758 12.0557C20.624 13.1559 20.7502 14.312 20.7502 15.5C20.7502 16.688 20.624 17.8441 20.4758 18.9443C20.2043 20.9613 18.5329 22.5558 16.4749 22.6504C15.0465 22.7161 13.596 22.75 12.0002 22.75C10.4045 22.75 8.95394 22.716 7.52563 22.6504C5.46758 22.5558 3.79623 20.9613 3.52466 18.9443C3.37653 17.8441 3.25024 16.688 3.25024 15.5C3.25024 14.312 3.37653 13.1559 3.52466 12.0557C3.74939 10.3865 4.93251 9.00705 6.50024 8.52734V6.75C6.50024 3.71243 8.96268 1.25 12.0002 1.25ZM12.0002 13.5C11.448 13.5 11.0002 13.9477 11.0002 14.5V16.5C11.0002 17.0523 11.448 17.5 12.0002 17.5C12.5524 17.4999 13.0002 17.0522 13.0002 16.5V14.5C13.0002 13.9478 12.5524 13.5001 12.0002 13.5ZM12.0002 3.25C10.0672 3.25 8.50024 4.817 8.50024 6.75V8.31055C9.61792 8.27087 10.7657 8.25 12.0002 8.25C13.2349 8.25 14.3825 8.27086 15.5002 8.31055V6.75C15.5002 4.81707 13.9331 3.25011 12.0002 3.25Z"
            fill={`url(#${id}-lock-a)`}
          />
          <defs>
            <linearGradient
              id={`${id}-lock-a`}
              x1="12.0002"
              y1="1.25"
              x2="12.0002"
              y2="22.75"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="18"
            y1="1.26172"
            x2="24.9231"
            y2="83.3002"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={light} />
            <stop offset="1" stopColor={dark} />
          </linearGradient>
          <radialGradient
            id={`${id}-b`}
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-24.3252 30.2485 -31.0051 -19.7356 27.6573 4.29258)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopOpacity="0" />
          </radialGradient>
          <linearGradient
            id={`${id}-c`}
            x1="18"
            y1="1.26172"
            x2="15.2308"
            y2="41.0694"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={`${id}-d`}
            x1="18"
            y1="1.26172"
            x2="15.2308"
            y2="41.0694"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 36 39"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
        fill={`url(#${id}-a)`}
      />
      <path
        d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
        fill={`url(#${id}-b)`}
        fillOpacity="0.4"
      />
      <path
        d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
        stroke={`url(#${id}-c)`}
        strokeWidth="1.8"
      />
      <path
        d="M15.7812 1.48535C17.1577 0.705187 18.8423 0.705187 20.2188 1.48535L26.2734 4.91699L26.2803 4.91992L26.2861 4.92383L32.2861 8.45117C33.6499 9.25313 34.4923 10.7129 34.5049 12.2949L34.5596 19.2549V19.2686L34.5049 26.2285C34.4923 27.8106 33.6499 29.2703 32.2861 30.0723L26.2861 33.5996L26.2803 33.6035L26.2734 33.6064L20.2188 37.0381C18.8423 37.8183 17.1577 37.8183 15.7812 37.0381L9.72656 33.6064L9.71973 33.6035L9.71387 33.5996L3.71387 30.0723C2.35009 29.2703 1.50771 27.8106 1.49512 26.2285L1.44043 19.2686V19.2549L1.49512 12.2949C1.50771 10.7129 2.35009 9.25313 3.71387 8.45117L9.71387 4.92383L9.71973 4.91992L9.72656 4.91699L15.7812 1.48535Z"
        stroke={`url(#${id}-d)`}
        strokeWidth="1.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7963 11.0704C21.4166 11.0137 20.8696 11.0117 20.0248 11.0117H17.9353C17.2447 11.0117 16.7858 11.0127 16.4314 11.0508C16.0951 11.087 15.922 11.1509 15.7905 11.2368C15.6588 11.3228 15.5298 11.4565 15.3598 11.7517C15.1809 12.0623 14.9934 12.484 14.713 13.1182L12.9014 17.2158C12.5901 17.9199 12.3928 18.371 12.2999 18.7069C12.2558 18.8665 12.2486 18.9562 12.2507 19.0025C12.2521 19.0343 12.2569 19.0384 12.2575 19.0389C12.2576 19.0394 12.2586 19.0448 12.2858 19.0585C12.3257 19.0785 12.4089 19.1082 12.5713 19.1323C12.9134 19.1833 13.4027 19.1853 14.1696 19.1853H14.6285C14.6459 19.1853 14.6632 19.1853 14.6805 19.1853C15.2511 19.1852 15.7585 19.1852 16.1604 19.2433C16.595 19.3061 17.0507 19.455 17.3817 19.8698C17.7121 20.2838 17.7572 20.761 17.7241 21.199C17.6934 21.6051 17.5835 22.1023 17.4595 22.6628L16.7616 25.8198C16.6579 26.2888 16.5747 26.6673 16.5158 26.9737C16.73 26.7495 16.9884 26.4644 17.308 26.111L22.8431 19.9904C23.1979 19.598 23.4344 19.3357 23.5921 19.1323C23.7127 18.9767 23.743 18.9088 23.7482 18.8983C23.7619 18.7797 23.7104 18.6644 23.6168 18.5963C23.6044 18.5927 23.5338 18.5703 23.3427 18.5557C23.0872 18.5361 22.7354 18.5356 22.2078 18.5356H22.1788C21.7962 18.5356 21.466 18.5356 21.2016 18.515C20.9344 18.4941 20.6309 18.447 20.3559 18.2854C19.8029 17.9605 19.4623 17.3688 19.4561 16.7285C19.4531 16.4105 19.5622 16.1239 19.6765 15.8808C19.7897 15.6401 19.9534 15.3521 20.1433 15.018L21.2295 13.1073C21.6484 12.3702 21.9185 11.8911 22.0583 11.5307C22.1253 11.358 22.1429 11.2589 22.1452 11.2072C22.1462 11.1847 22.1441 11.1755 22.144 11.1749C22.1439 11.1748 22.144 11.175 22.144 11.1749C22.1438 11.1746 22.1433 11.1735 22.1425 11.172C22.1418 11.1709 22.1414 11.1702 22.1411 11.1698C22.1406 11.1694 22.139 11.168 22.1359 11.1658C22.1321 11.1633 22.1257 11.1592 22.1158 11.1541C22.0713 11.1311 21.9782 11.0976 21.7963 11.0704ZM22.0178 9.58686C22.5426 9.6652 23.114 9.85471 23.4416 10.4221C23.7683 10.9881 23.6488 11.5779 23.4568 12.0731C23.272 12.5496 22.9443 13.126 22.5626 13.7974L21.4616 15.7342C21.2534 16.1005 21.1193 16.3375 21.0339 16.5191C20.9698 16.6554 20.9581 16.7112 20.9562 16.7205C20.9594 16.8315 21.0181 16.9318 21.1094 16.9883C21.1192 16.9915 21.1733 17.0082 21.3184 17.0195C21.5172 17.0351 21.788 17.0356 22.2078 17.0356H22.2385C22.7273 17.0356 23.1374 17.0356 23.4572 17.0601C23.7665 17.0838 24.1307 17.1363 24.436 17.3393C25.0289 17.7334 25.3372 18.4366 25.229 19.1391C25.1734 19.5004 24.9683 19.8051 24.7778 20.0511C24.5808 20.3052 24.3051 20.6101 23.9761 20.9738L18.3845 27.1569C17.8716 27.7242 17.4397 28.2017 17.0884 28.508C16.9098 28.6638 16.6988 28.8238 16.4633 28.9194C16.204 29.0246 15.8618 29.0693 15.5219 28.8922C15.1827 28.7155 15.0234 28.4103 14.96 28.1391C14.9022 27.8921 14.9106 27.6277 14.9342 27.3913C14.9807 26.9265 15.1199 26.2968 15.2855 25.5481L15.9837 22.3894C16.1222 21.7629 16.2068 21.372 16.2284 21.0859C16.2385 20.952 16.2309 20.8788 16.2229 20.8414C16.2172 20.8149 16.2121 20.8088 16.2097 20.806C16.2096 20.8058 16.2099 20.8061 16.2097 20.806C16.2096 20.8058 16.2089 20.805 16.2088 20.8048C16.2066 20.8019 16.2023 20.7962 16.1791 20.7855C16.1457 20.77 16.0774 20.7469 15.9458 20.7279C15.6643 20.6872 15.2674 20.6853 14.6285 20.6853L14.1125 20.6853C13.4196 20.6854 12.8164 20.6854 12.3503 20.616C11.8573 20.5425 11.3294 20.3661 10.9979 19.8533C10.6672 19.3418 10.7212 18.788 10.8541 18.3072C10.9801 17.8516 11.2249 17.2981 11.5065 16.6612C11.5142 16.6439 11.5218 16.6266 11.5295 16.6093L13.3568 12.4762C13.6174 11.8868 13.8365 11.3912 14.0599 11.0031C14.2968 10.5919 14.5704 10.2422 14.9702 9.98103C15.3702 9.71969 15.8 9.61006 16.2711 9.55942C16.7151 9.51169 17.2551 9.5117 17.8963 9.51172L20.0841 9.51172C20.8527 9.51167 21.5138 9.51163 22.0178 9.58686Z"
        fill={`url(#${id}-e)`}
      />
      <defs>
        <linearGradient
          id={`${id}-a`}
          x1="18"
          y1="1.26172"
          x2="24.9231"
          y2="83.3002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={light} />
          <stop offset="1" stopColor={dark} />
        </linearGradient>
        <radialGradient
          id={`${id}-b`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-24.3252 30.2485 -31.0051 -19.7356 27.6573 4.29258)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={`${id}-c`}
          x1="18"
          y1="1.26172"
          x2="15.2308"
          y2="41.0694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${id}-d`}
          x1="18"
          y1="1.26172"
          x2="15.2308"
          y2="41.0694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${id}-e`}
          x1="18.0004"
          y1="9.51172"
          x2="15.991"
          y2="30.9906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TierBadge;
